/**
 * The screens speak the company's own locale: an Irish company reads en-IE.
 * The locale comes from the company's formatting, set from its country when the
 * company is created; the text switches as soon as that loads.
 */
import type { QueryClient } from '@tanstack/react-query';

import { COMPANY_FORMATTING_KEY, type CompanyFormatting } from './companyMoney';

export interface LanguageSwitch {
  language: string;
  changeLanguage: (lng: string) => unknown;
}

const isFormattingKey = (key: readonly unknown[]): boolean =>
  key.length === COMPANY_FORMATTING_KEY.length && COMPANY_FORMATTING_KEY.every((k, i) => key[i] === k);

/** Follow the company's locale from now on; returns the unsubscribe. */
export function followCompanyLocale(queryClient: QueryClient, i18n: LanguageSwitch): () => void {
  const apply = (data: CompanyFormatting | undefined): void => {
    const locale = data?.locale;
    if (locale && i18n.language !== locale) void i18n.changeLanguage(locale);
  };
  apply(queryClient.getQueryData<CompanyFormatting>(COMPANY_FORMATTING_KEY));
  return queryClient.getQueryCache().subscribe((event) => {
    if (event.type !== 'updated' || event.action.type !== 'success') return;
    if (!isFormattingKey(event.query.queryKey)) return;
    apply(event.query.state.data as CompanyFormatting | undefined);
  });
}
